import React from "react";
import { RawLinkButton, IRawLinkButtonProps } from "../LinkButton";
import Theme from "../../Theme";

export const FormButton = (props: IRawLinkButtonProps) => {
  return (
    <RawLinkButton
      bgColorOverride={Theme.colors.buttonPrimary}
      bgColorHoverOverride={Theme.colors.buttonPrimaryHover}
      bgColorDisabledOverride={Theme.colors.buttonPrimaryDisabled}
      {...props}
    />
  );
};

export const SecondaryFormButton = (props: IRawLinkButtonProps) => {
  return (
    <RawLinkButton
      bgColorOverride={Theme.colors.buttonSecondary}
      bgColorHoverOverride={Theme.colors.buttonSecondaryHover}
      bgColorDisabledOverride={Theme.colors.buttonSecondaryDisabled}
      {...props}
    />
  );
};

export const NegativeFormButton = (props: IRawLinkButtonProps) => {
  return (
    <RawLinkButton
      bgColorOverride={Theme.colors.buttonDanger}
      bgColorHoverOverride={Theme.colors.buttonDangerHover}
      bgColorDisabledOverride={Theme.colors.buttonDangerDisabled}
      {...props}
    />
  );
};

export default FormButton;
